

import { Link } from 'react-router-dom';

import Followus from './Followus';

interface FooterLink {
  href: string;
  label: string;
}

interface FooterSection {
  title: string;
  links: FooterLink[];
}

export default function Footer() {
  const sections: FooterSection[] = [

{
  title: 'Services',
  links: [
    {
      href: 'https://lemolite.com/services/ui-ux-design',
      label: 'UI/UX Design',
    },
    {
      href: 'https://lemolite.com/services/e-commerce',
      label: 'E-Commerce',
    },
    {
      href: 'https://lemolite.com/services/web-development',
      label: 'Web Development',
    },
    {
      href: 'https://lemolite.com/services/mobile-app-development',
      label: 'Mobile App Development',
    },
    {
      href: 'https://lemolite.com/services/custom-software-development',
      label: 'Custom Software Development',
    },
    {
      href: 'https://lemolite.com/services/ot-cybersecurity',
      label: 'Secure Product Lifecycle Solutions',
    },
  ],
},
{
  title: 'Intelligent Automation',
  links: [
    {
      href: 'https://lemolite.com/services/ai-ml-development',
      label: 'AI & ML Development',
    },
    {
      href: 'https://lemolite.com/services/internet-of-things',
      label: 'Internet of Things',
    },
    {
      href: 'https://lemolite.com/services/chatbot-development',
      label: 'Chatbot Development',
    },
    {
      href: 'https://lemolite.com/services/voicebot-development',
      label: 'Voicebot Development',
    },
  ],
},
{
  title: 'Hire Resources',
  links: [
    {
      href: 'https://lemolite.com/services/hire-python-developer',
      label: 'Hire Python Developers',
    },
    {
      href: 'https://lemolite.com/services/hire-mern-developer',
      label: 'Hire MERN Developers',
    },
    {
      href: 'https://lemolite.com/services/hire-reactjs-developer',
      label: 'Hire React JS Developers',
    },
    {
      href: 'https://lemolite.com/services/hire-nodejs-developer',
      label: 'Hire Node JS Developers',
    },
    {
      href: 'https://lemolite.com/services/hire-php-developer',
      label: 'Hire PHP Developers',
    },
    {
      href: 'https://lemolite.com/services/hire-laravel-developer',
      label: 'Hire Laravel Developers',
    },
    {
      href: 'https://lemolite.com/services/hire-angular-developer',
      label: 'Hire Angular Developers',
    },
    {
      href: 'https://lemolite.com/services/hire-vuejs-developer',
      label: 'Hire Vue JS Developers',
    },
    {
      href: 'https://lemolite.com/services/hire-flutter-developer',
      label: 'Hire Flutter Developers',
    },
    {
      href: 'https://lemolite.com/services/hire-shopify-developer',
      label: 'Hire Shopify Developers',
    },
  ],
},
    {
      title: 'Tech Stack',
      links: [
        {
          href: 'https://lemolite.com/techstack/reactjs-development',
          label: 'React JS Development',
        },
        {
          href: 'https://lemolite.com/techstack/angular-development',
          label: 'Angular Development',
        },
        {
          href: 'https://lemolite.com/techstack/vuejs-development',
          label: 'Vue JS Development',
        },
        {
          href: 'https://lemolite.com/techstack/flutter-development',
          label: 'Flutter Development',
        },
        {
          href: 'https://lemolite.com/techstack/nodejs-development',
          label: 'Node JS Development',
        },
        {
          href: 'https://lemolite.com/techstack/laravel-development',
          label: 'Laravel Development',
        },
        {
          href: 'https://lemolite.com/techstack/php-development',
          label: 'PHP Development',
        },
        {
          href: 'https://lemolite.com/techstack/mern-development',
          label: 'MERN Development',
        },
        {
          href: 'https://lemolite.com/techstack/python-development',
          label: 'Python Development',
        },
        {
          href: 'https://lemolite.com/techstack/shopify-development',
          label: 'Shopify Development',
        },
      ],
    },
    {
      title: 'Company',
      links: [
        { href: 'https://lemolite.com/blog', label: 'Blog' },
        { href: 'https://lemolite.com/careers', label: 'Careers' },
        { href: 'https://lemolite.com/about-us', label: 'About Us' },
        { href: 'https://lemolite.com/startups', label: 'Startups' },
        { href: 'https://lemolite.com/contact-us', label: 'Contact Us' },
        {
          href: 'https://lemolite.com/life-at-lemolite',
          label: 'Life@Lemolite',
        },
      ],
    },
  ];

  return (
    <footer className="bg-[#000000] text-white" id="black-section">
      <div className="container mx-auto px-4 pb-6 pt-10">
        {/* Link Sections */}
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
          {sections.map(({ title, links }) => (
            <div key={title}>
              <h3 className="mb-4 text-lg font-semibold">{title}</h3>

              <ul className="space-y-2 text-[15px] font-light capitalize">
                {links.map(({ href, label }) => (
                  <li key={href}>
                    <Link to={href} className="transition hover:text-gray-300">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <hr className="mb-4 mt-6 border-gray-700" />

        {/* Bottom Section */}
        <div className="flex flex-col items-center justify-between gap-6 text-sm md:flex-row">
          {/* Social Icons */}
          <Followus />

          {/* Copyright + Links */}
          <div className="text-center">
            <p>
              © Lemolite Technologies LLP {new Date().getFullYear()} — All
              rights reserved
            </p>

            <div className="mt-2 flex flex-wrap justify-center gap-4">
              <Link to="https://lemolite.com/terms-conditions" className="hover:underline">
                Terms & Conditions
              </Link>

              <Link to="https://lemolite.com/privacy-policy" className="hover:underline">
                Privacy Policy
              </Link>

              <Link to="https://lemolite.com/site-map" className="hover:underline">
                Sitemap
              </Link>
            </div>
          </div>

          {/* Reviews */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.google.com/search?q=Lemolite+Technologies+LLP+Reviews"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/googlereview.svg"
                alt="Lemolite Technologies — 5-star Google Reviews"
                width={96}
                height={40}
                className="object-contain"
              />
            </a>

            <a
              href="https://clutch.co/profile/lemolite-technologies-llp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/clutchreview.svg"
                alt="Lemolite Technologies — Top-Rated on Clutch.co.uk"
                width={96}
                height={40}
                className="object-contain"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Metricool pixel */}
      <img
        src="https://tracker.metricool.com/c3po.jpg?hash=f2262c22e03264dd900d58da0715c45f"
        alt=""
        className="hidden"
      />
    </footer>
  );
}
